import { ElevationEnum } from '../../types';

type ElevationProps = {
	elevation?: ElevationEnum;
};

export const elevationDecorator = ({ elevation }: ElevationProps) => {
	switch (elevation) {
		case 5:
			return `
      	box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.15);
      `;
		case 4:
			return `
      	box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.15);
      `;
		case 3:
			return `
      	box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.15);
      `;
		case 2:
			return `
      	box-shadow: 0px 2.5px 5px rgba(0, 0, 0, 0.15);
      `;
		case 1:
			return `
      	box-shadow: 0px 1.25px 2.5px rgba(0, 0, 0, 0.15);
      `;
		case -1:
			return `
      	box-shadow: inset 0px 2.5px 5px rgba(0, 0, 0, 0.15);
      `;
		case -2:
			return `
      	box-shadow: inset 0px 5px 10px rgba(0, 0, 0, 0.15);
      `;
		case -3:
			return `
      	box-shadow: inset 0px 10px 15px rgba(0, 0, 0, 0.15);
      `;
		case 0:
			return `
				border: 1px solid #fffffe;
				box-shadow: none;
			`;
		default:
			return '';
	}
};
